'use strict'

document.addEventListener("DOMContentLoaded", function (event) {
   if ("IntersectionObserver" in window) {
      if (document.querySelectorAll('picture.lazy').length > 0) {
         let lazyPictures = [].slice.call(document.querySelectorAll("picture.lazy"));

         const lazyPictureObserver =
            new IntersectionObserver(function (entries, observer) {
               entries.forEach(function (entry) {
                  if (entry.isIntersecting) {
                     let lazyPicture = entry.target;
                     let lazyPictureChilds = lazyPicture.childNodes;
                     lazyPictureChilds.forEach(function (lazyPictureChild) {
                        if (lazyPictureChild.tagName === 'SOURCE' || lazyPictureChild.tagName === 'IMG') {
                           lazyPictureChild.srcset = lazyPictureChild.dataset.srcset;
                        }
                     });
                     lazyPicture.classList.add('animation-fade-in');
                     lazyPicture.classList.remove("lazy--styles");
                     lazyPictureObserver.unobserve(lazyPicture);
                  }
               });
            });

         lazyPictures.forEach(function (lazyImage) {
            lazyPictureObserver.observe(lazyImage);
         });
      }

      if (document.querySelectorAll('picture.lazy-blur').length > 0) {
         let lazyBlurPictures = [].slice.call(document.querySelectorAll("picture.lazy-blur"));

         const lazyBlurObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
               if (entry.isIntersecting) {
                  let picture = entry.target;
                  let img = picture.querySelector('img.lazy-img-blur');
                  let sources = picture.querySelectorAll('source');

                  sources.forEach(source => {
                     if (source.dataset.srcset) {
                        source.srcset = source.dataset.srcset;
                     }
                  });

                  if (img && img.dataset.srcset) {
                     img.srcset = img.dataset.srcset;
                  }

                  picture.classList.add('loaded');
                  picture.classList.remove('lazy--styles');
                  lazyBlurObserver.unobserve(picture);
               }
            });
         }, {
            threshold: 0.25
         });

         lazyBlurPictures.forEach(picture => {
            lazyBlurObserver.observe(picture);
         });
      }

      if (document.querySelectorAll('img.lazy').length > 0) {
         let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

         const lazyImageObserver =
            new IntersectionObserver((entries, observer) => {
               entries.forEach((entry) => {
                  if (entry.isIntersecting) {
                     const lazyImage = entry.target
                     lazyImage.src = lazyImage.dataset.src;
                     lazyImage.classList.add('animation-fade-in');
                     lazyImage.classList.remove("lazy--styles");
                     lazyImageObserver.unobserve(lazyImage);
                  }
               })
            });

         lazyImages.forEach(function (lazyImage) {
            lazyImageObserver.observe(lazyImage);
         });
      }

      if (document.querySelectorAll('video.lazy').length > 0) {
         let lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

         const lazyVideoObserver =
            new IntersectionObserver(function (entries, observer) {
               entries.forEach(function (video) {
                  if (video.isIntersecting) {
                     for (let source in video.target.children) {
                        let videoSource = video.target.children[source];
                        if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                           videoSource.src = videoSource.dataset.src;
                        }
                     }

                     if (video.target.getAttribute('data-poster')) {
                        video.target.poster = video.target.getAttribute('data-poster');
                     }

                     video.target.load();
                     video.target.classList.remove("lazy--styles");
                     video.target.classList.add('animation-fade-in');
                     lazyVideoObserver.unobserve(video.target);
                  }
               });
            });

         lazyVideos.forEach(function (lazyVideo) {
            lazyVideoObserver.observe(lazyVideo);
         });
      }

      if (document.querySelectorAll('video.lazy-poster').length > 0) {
         let lazyPosters = [].slice.call(document.querySelectorAll("video.lazy-poster"));

         const lazyPosterObserver =
            new IntersectionObserver(function (entries, observer) {
               entries.forEach(function (video) {
                  if (video.isIntersecting) {

                     if (video.target.getAttribute('data-poster')) {
                        video.target.poster = video.target.getAttribute('data-poster');
                     }

                     video.target.load();
                     video.target.classList.remove("lazy--styles");
                     video.target.classList.add('animation-fade-in');
                     lazyPosterObserver.unobserve(video.target);
                  }
               });
            });

         lazyPosters.forEach(function (lazyPoster) {
            lazyPosterObserver.observe(lazyPoster);
         });
      }

      if (document.querySelectorAll('.lazy-bg').length > 0) {
         let lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-bg"));

         const lazyBackgroundObserver =
            new IntersectionObserver(function (entries, observer) {
               entries.forEach(function (entry) {
                  if (entry.isIntersecting) {
                     const lazyBg = entry.target
                     if (lazyBg.getAttribute('data-bg')) {
                        lazyBg.style.backgroundImage = lazyBg.getAttribute('data-bg');
                     }
                     lazyBg.classList.add('animation-fade-in');
                     lazyBg.classList.remove("lazy--styles");
                     lazyBackgroundObserver.unobserve(lazyBg);

                  }
               });
            });

         lazyBackgrounds.forEach(function (lazyBackground) {
            lazyBackgroundObserver.observe(lazyBackground);
         });
      }

      if (document.querySelectorAll('.lazy-bg-responsive').length > 0) {
         let lazyBackgroundsResponsive = [].slice.call(document.querySelectorAll(".lazy-bg-responsive"));

         const lazyBackgroundResponsiveObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
               if (entry.isIntersecting) {
                  const lazyBgRes = entry.target;

                  // Establece la imagen para dispositivos móviles, si existe
                  if (window.innerWidth <= 600 && lazyBgRes.getAttribute('data-bg1x')) {
                     lazyBgRes.style.setProperty('--bg1x', `url(${lazyBgRes.getAttribute('data-bg1x')})`);
                  }
                  // Establece la imagen para desktop, si existe
                  else if (window.innerWidth <= 1440 && lazyBgRes.getAttribute('data-bg2x')) {
                     lazyBgRes.style.setProperty('--bg2x', `url(${lazyBgRes.getAttribute('data-bg2x')})`);
                  }
                  // Para big desktop, o si no hay imagen específica para móviles/tablets
                  else if (lazyBgRes.getAttribute('data-bg3x')) {
                     lazyBgRes.style.setProperty('--bg3x', `url(${lazyBgRes.getAttribute('data-bg3x')})`);
                  }

                  lazyBgRes.classList.add('animation-fade-in');
                  lazyBgRes.classList.remove("lazy--styles");
                  lazyBackgroundResponsiveObserver.unobserve(lazyBgRes);
               }
            });
         });

         lazyBackgroundsResponsive.forEach(function (lazyBackgroundResponsive) {
            lazyBackgroundResponsiveObserver.observe(lazyBackgroundResponsive);
         });
      }

   } else {
      // Not supported, load all images immediately
      lazyPictures.forEach(function (image) {
         image.nextElementSibling.src = image.nextElementSibling.dataset.srcset;
      });
   }
});